// ====== SLEEP PRODUCT FUNCTIONS ====== //

document.addEventListener( 'DOMContentLoaded', function () {

  // 4 STAGES OF SLEEP
  
  $(document).ready(function() {

    setInterval(function() {

      var current = $('.stage-active').attr('id');
      
      console.log(current);
      
      var the_number = current.match(/\d+/);
      var the_number = +the_number;
      
      console.log(the_number);

      if (the_number < 4) {
        $('.stage-active').next().trigger('click');
      } else {
        $('#stage1').trigger('click');
      }
    }, 8000);

  });

  $(".timeline-container li").on('click', function() {

    $(this).siblings().removeClass('stage-active');
    $(this).addClass('stage-active');

    $(this).removeClass('stage-previous');
    $(this).siblings().removeClass('stage-previous');
    $(this).prevAll().addClass('stage-previous');

    var the_text = $(this).text()
    var my_array = $(this).text().split(" ");
    var contentid = "#content" + my_array[1];

    $('.stage-isactive').removeClass('stage-isactive');
    $(contentid).addClass('stage-isactive');

  });

});